// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interest-table .top-section{
  clear:both;
  display:table;
  width:100%;
}

.interest-table .griddle-filter{
  position: absolute;
  top: -75px;
  right: 7px;
  width: 100%;
  padding-left: 14px;
}

.interest-table .griddle-filter input {
  padding: 10px 11px;
  width: 100%;
  border: 1px solid #dcdcdc;
  font-weight: 400;
}

@media (max-width: 992px) {
  /* scope to griddle so applications page doest get affected */
  .interest-table .filter-container {
    display: none;
  }
}

.interest-table .griddle-settings-toggle{
  float:left;
  width:50%;
  text-align:right;
}

.interest-table .griddle-settings{
  background-color:#FFF;
  border:1px solid #DDD;
  color:#222;
  padding:10px;
  margin-bottom:10px;
}

.interest-table .griddle-settings .griddle-columns{
  clear:both;
  display:table;
  width:100%;
  border-bottom:1px solid #EDEDED;
  margin-bottom:10px;
}

.interest-table .griddle-settings .griddle-column-selection{
  float:left;
  width:20%;
}
.interest-table table {
  width: 100%;
}

.interest-table th {
  border: 0px;
  border-bottom: 1px solid #DDD;
  color: #32445A;
  font-size: 13px;
  font-weight: 600;
  padding: 5px 4px;
}

.interest-table td {
  border-bottom: 1px solid #D6D6D6;
  color: #505050;
  font-size: 13px;
  padding: 9px 4px;
}

.interest-table .stage-select {
    line-height: 22px;
    padding: 0 18px 0 8px;
    font-size: 13px;
    background-position-x: 106%;
    /* reset select styles from haven component */
    -webkit-appearance: initial;
    -moz-appearance: initial;
    width: initial;
}

.interest-table .footer-container{
  padding: 15px 0 0 0;
  border: 0px;
  color: #adadad;
  font-size: 12px;
}

.interest-table .griddle-previous,
.interest-table .griddle-page,
.interest-table .griddle-next {
  float:left;
  width:33%;
  min-height:1px;
  margin-top:5px;
}

.interest-table .griddle-page{
  text-align:center;
}

.interest-table .griddle-next{
  text-align:right;
}

.interest-table .griddle-footer button {
  background: white;
  border: none;
  box-shadow: 0 0 0 1px rgba(63, 60, 68, 0.11),0 1px 3px rgba(62, 63, 68, 0.2),0 1px 2px rgba(0, 0, 0, 0.06);
  font-size: 12px;
  padding: 5px 15px;
  color: #797979;
}

.interest-table .griddle-footer select {
  border: 1px solid #adadad;
  border-radius: 0;
  background-color: white;
}

.interest-table-row-checked {
  background-color: rgb(253, 253, 204);
}

.interest-table tbody tr:hover {
  background: #f7f7f7;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests/interests-table/interests-table.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D;IACE,aAAa;EACf;AACF;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,2BAA2B;IAC3B,6CAA6C;IAC7C,2BAA2B;IAC3B,wBAAwB;IACxB,cAAc;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,UAAU;EACV,SAAS;EACT,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,0GAA0G;EAC1G,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".interest-table .top-section{\n  clear:both;\n  display:table;\n  width:100%;\n}\n\n.interest-table .griddle-filter{\n  position: absolute;\n  top: -75px;\n  right: 7px;\n  width: 100%;\n  padding-left: 14px;\n}\n\n.interest-table .griddle-filter input {\n  padding: 10px 11px;\n  width: 100%;\n  border: 1px solid #dcdcdc;\n  font-weight: 400;\n}\n\n@media (max-width: 992px) {\n  /* scope to griddle so applications page doest get affected */\n  .interest-table .filter-container {\n    display: none;\n  }\n}\n\n.interest-table .griddle-settings-toggle{\n  float:left;\n  width:50%;\n  text-align:right;\n}\n\n.interest-table .griddle-settings{\n  background-color:#FFF;\n  border:1px solid #DDD;\n  color:#222;\n  padding:10px;\n  margin-bottom:10px;\n}\n\n.interest-table .griddle-settings .griddle-columns{\n  clear:both;\n  display:table;\n  width:100%;\n  border-bottom:1px solid #EDEDED;\n  margin-bottom:10px;\n}\n\n.interest-table .griddle-settings .griddle-column-selection{\n  float:left;\n  width:20%;\n}\n.interest-table table {\n  width: 100%;\n}\n\n.interest-table th {\n  border: 0px;\n  border-bottom: 1px solid #DDD;\n  color: #32445A;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 5px 4px;\n}\n\n.interest-table td {\n  border-bottom: 1px solid #D6D6D6;\n  color: #505050;\n  font-size: 13px;\n  padding: 9px 4px;\n}\n\n.interest-table .stage-select {\n    line-height: 22px;\n    padding: 0 18px 0 8px;\n    font-size: 13px;\n    background-position-x: 106%;\n    /* reset select styles from haven component */\n    -webkit-appearance: initial;\n    -moz-appearance: initial;\n    width: initial;\n}\n\n.interest-table .footer-container{\n  padding: 15px 0 0 0;\n  border: 0px;\n  color: #adadad;\n  font-size: 12px;\n}\n\n.interest-table .griddle-previous,\n.interest-table .griddle-page,\n.interest-table .griddle-next {\n  float:left;\n  width:33%;\n  min-height:1px;\n  margin-top:5px;\n}\n\n.interest-table .griddle-page{\n  text-align:center;\n}\n\n.interest-table .griddle-next{\n  text-align:right;\n}\n\n.interest-table .griddle-footer button {\n  background: white;\n  border: none;\n  box-shadow: 0 0 0 1px rgba(63, 60, 68, 0.11),0 1px 3px rgba(62, 63, 68, 0.2),0 1px 2px rgba(0, 0, 0, 0.06);\n  font-size: 12px;\n  padding: 5px 15px;\n  color: #797979;\n}\n\n.interest-table .griddle-footer select {\n  border: 1px solid #adadad;\n  border-radius: 0;\n  background-color: white;\n}\n\n.interest-table-row-checked {\n  background-color: rgb(253, 253, 204);\n}\n\n.interest-table tbody tr:hover {\n  background: #f7f7f7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
